/* @ngInject */
const accountMenu = (
  $state,
  labels,
  routes,
  userService
) => {
  const self = [{
    label: labels.account.changePassword,
    go: () => {
      $state.go(routes.account.edit.path)
    },
    display: () => {
      return true
    },
  }, {
    label: labels.account.createUser,
    go: () => {
      $state.go(routes.account.new.path)
    },
    display: () => {
      return userService.isAdmin()
    },
  }, {
    label: labels.account.consult,
    go: () => {
      $state.go(routes.account.consult.path)
    },
    display: () => {
      return true
    },
  },]

  return self
}

export default accountMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/account.menu.js